export { default } from './Detalls';
